export default __webpack_public_path__ + "static/media/soehne-leicht-kursiv.8e015982.ttf";